import * as React from "react"
import { Link } from "gatsby"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const PageTitle = ({
  title,
  pageParentTitle,
  pageParentPath,
  intro,
  backgroundImage,
}) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          extension: { regex: "/(jpg|jpeg|png)/" }
          relativeDirectory: { eq: "backgrounds" }
        }
      ) {
        edges {
          node {
            relativePath
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)

  const imageNode = data.allFile.edges.find(
    edge => edge.node.relativePath === `backgrounds/${backgroundImage}`
  )
  const image = imageNode
    ? getImage(imageNode.node.childImageSharp.gatsbyImageData)
    : null

  return (
    <div className={"relative bg-gradient-to-tr from-navy-600 to-navy-900"}>
      <div
        className={
          "absolute bottom-0 w-full h-[2px] bg-gradient-to-r from-navy via-yellow to-navy z-0"
        }
      />

      {image && (
        <div className={"w-full h-full absolute top-0"}>
          <GatsbyImage
            image={image}
            alt="Background"
            className={"w-full h-full object-cover opacity-50"}
          />
        </div>
      )}

      <div
        className={
          "w-full h-[90%] absolute bottom-0 left-0 bg-gradient-to-t from-navy-800 to-transparent z-10"
        }
      />

      <div className={"relative max-w-4xl mx-auto px-4 sm:px-6 z-20"}>
        <div
          className={
            `relative flex flex-col items-center justify-center pt-48 ${image ? 'lg:pt-72' : 'lg:pt-24'} pb-24`
          }
        >
          <h1 className={"text-white text-5xl text-center mb-6"}>{title}</h1>

          <ul
            className={
              "flex flex-row justify-center gap-2 text-sm uppercase font-bold text-white mb-6"
            }
          >
            <li>
              <Link
                to={"/"}
                className={
                  "text-yellow hover:text-yellow-600 transition duration-500 ease-in-out"
                }
              >
                Home
              </Link>
            </li>

            {pageParentTitle && (
              <li>
                <span className={"text-yellow mr-2"}>/</span>
                <Link
                  to={pageParentPath}
                  className={
                    "hover:text-yellow transition duration-500 ease-in-out"
                  }
                >
                  {pageParentTitle}
                </Link>
              </li>
            )}

            <li className={"font-normal text-gray-200"}>
              <span className={"text-yellow mr-2"}>/</span>
              {title}
            </li>
          </ul>

          {intro && (
            <p
              className={
                "text-gray-100 text-lg lg:text-xl font-medium text-center text-pretty px-8 lg:px-16"
              }
            >
              {intro}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default PageTitle
